import { createAction } from 'typesafe-actions';

import ActionTypes from './constants';

export const setIsBodyScrollable = createAction(
  ActionTypes.SET_IS_BODY_SCROLLABLE,
  (v: boolean) => v
)();
